import { Component, Input, ContentChild, TemplateRef, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CurrencyEnum } from '@shared/models/enums/currency.enum';

@Component({
  selector: 'flow-form-select-currency',
  templateUrl: './form-select-currency.component.html',
  styleUrls: ['./form-select-currency.component.scss'],
})
export class FormSelectCurrencyComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() options: any[] = [];
  @Input() required: boolean = false;
  @Input() infoTooltip: string = '';
  @Input() panelClass: string = '';

  value: any;
  disabled = false;
  CurrencyEnum = CurrencyEnum;

  constructor(@Optional() @Self() protected control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: any) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}